import React from 'react';
import RentMap from '../RentMap';
import { siteConfig } from '../../config/site';

export function MapSubmissionSection() {
  return (
    <section id={siteConfig.anchors.map} className="scroll-mt-20 bg-cta-gradient pb-12 pt-4 md:pb-16 md:pt-6">
      <div className="mx-auto max-w-9xl px-3 sm:px-6 lg:px-8">
        <div className="mx-auto mb-6 max-w-4xl text-center text-white md:mb-8">
          <h2 className="font-display text-2xl font-bold md:text-3xl">
            Marcá tu lote y generá el análisis gratis
          </h2>
          <p className="mt-2 text-sm text-white/70 md:text-base">
            Buscá tu campo y dibujá un lote en el mapa o subí un archivo KML/KMZ del lote — hasta{' '}
            {siteConfig.freeHa} ha gratis.
          </p>
        </div>

        <div className="overflow-visible rounded-2xl bg-white shadow-glow md:overflow-hidden">
          <RentMap />
        </div>
      </div>
    </section>
  );
}
